import * as React from 'react'
import { getClassNameModern } from '../../../../../../Shared/Frontend/utils/getClassNameFromStyle'
import type { MediaBlockNested } from '../../modernBlocks.state'
import { MediaBlockLayout } from '../mediaBlock/mediaBlock.layout'

export type MediaBlockNestedClassNames = Partial<{
  block: string
  inner: string
}>

export const mediaBlockNestedClasses: MediaBlockNestedClassNames = {
  block: 'block--nested block--media-nested',
  inner: 'block__inner',
}

export const MediaBlockNestedLayout = (props: MediaBlockNested & { videoChild: JSX.Element }) => {
  const { type, index } = props
  return (
    <div key={index} className={getClassNameModern(mediaBlockNestedClasses, 'block', '')}>
      <div className={getClassNameModern(mediaBlockNestedClasses, 'inner', 'py-3')}>
        {type == 'image' ? (
          <MediaBlockLayout.Visual item={{ ...props }} id={`image-nested-${index}`}>
            <MediaBlockLayout.Image displayOption='content-width' originalSize={props.type == 'image' ? props.originalSize : { showinOriginalSize: false }} image={props.type == 'image' ? props.image : undefined} />
          </MediaBlockLayout.Visual>
        ) : type == 'video' ? (
          <MediaBlockLayout.Visual item={{ ...props }} id={`video-nested-${index}`}>
            {props.videoChild}
          </MediaBlockLayout.Visual>
        ) : (
          <></>
        )}
      </div>
    </div>
  )
}
